<template>
  <div class="main-content login">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Login</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="login-container">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-push-3">
            <div class="border-1px p-25">
              <h4 class="text-theme-colored text-uppercase m-0">Login Pasien</h4>
              <div class="line-bottom mb-30"></div>
              <p>
                Silahkan login menggunakan email dan password yang telah didaftarkan. Jika belum memiliki akun silahkan mendaftarkan akun
                <b-link :to="{ path: '/sign-up' }">disini</b-link>
              </p>
              <form
                id="login-form"
                name="login-form"
                class="mt-30"
                method="post"
                action
                novalidate="novalidate"
                onsubmit="return false"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <input
                        name="email"
                        :disabled="disabled"
                        v-model="form_email"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Enter Email Address"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <input
                        :disabled="disabled"
                        name="password"
                        v-model="form_password"
                        class="form-control required password"
                        type="password"
                        placeholder="Enter Password"
                        aria-required="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0 mt-20">
                  <button
                    :disabled="disabled"
                    type="submit"
                    @click="postLogin"
                    class="btn btn-circled btn-dark btn-theme-colored"
                  >
                    <i v-if="show_loading" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                    <span v-if="!show_loading">Masuk</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import router from "../router";
import api from "../services/api";

export default {
  data() {
    return {
      form_email: "",
      form_password: "",
      disabled: false,
      show_loading: false,
    };
  },
  methods: {
    postLogin() {
      this.show_loading = true;
      this.disabled = true;

      let payload = {
        email: this.form_email,
        password: this.form_password,
      };

      api
        .post(api.route.post.login, payload)
        .then((res) => {
          let status = res.status;
          let message = res.message;
          let data = res.data;
          if (status) {
            let dataLogin = {
              logged: true,
              email: data.email,
              phone: data.phone,
              rm: data.rm,
              user_privilege_id: data.user_privilege_id,
              verify: data.verify,
            };
            localStorage.setItem("user_data", JSON.stringify(dataLogin));
            router.push({ name: "home" });
            window.location.reload();
          }

          alert(message);
          this.show_loading = false;
          this.disabled = false;
        })
        .catch((err) => {
          alert(err);
          this.show_loading = false;
          this.disabled = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Login.vue